import { useSelector } from "react-redux";
import { RootState } from "store";
import { Marketplace } from "@spike/marketplace-model";

export const useMarketplace = (): Marketplace => {
	const marketplace = useSelector<RootState, Marketplace>(state => state.marketplace.marketplace);
  return marketplace;
};

export default useMarketplace;